export default "__VITE_ASSET__BeiuEJRn__"